export default __webpack_public_path__ + "static/media/exact.d822d54b.svg";